import classnames from 'classnames';
import React, { FC } from 'react';
import { GalleryFileControls } from '../../../../components/layouts/Gallery/GalleryFile/GalleryFileControls';
import { GalleryFileThumbnail } from '../../../../components/layouts/Gallery/GalleryFile/GalleryFileThumbnail';
import { MediaManagerSDKFile } from '../../../../utils/media-manager-sdk';
import { isReady } from '../../../../utils/media-manager-sdk/transcoding';
import { IOuter } from '../ItemDemonstration.types';
import styles from './Demonstration.scss';

export const Music: FC<IOuter> = ({ item, className, saveRef }) => (
  <GalleryFileThumbnail
    className={classnames(styles.labeled, className)}
    thumbnailClassName={styles.labeledThumbnail}
    file={item as MediaManagerSDKFile}
    width={150}
    height={150}
    dataHook="expanded-view-file-demonstration"
    controls={isReady(item) && <GalleryFileControls file={item as MediaManagerSDKFile} />}
    saveRef={saveRef}
  />
);
